module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "8541.838e03c4.jpg";